export default __webpack_public_path__ + "static/media/lower-repetition-level.32db768c.svg";